import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
      document.title = "HTTP Status Code - 404 not found";
        }, []);

  return (
    <>
      <Helmet>
          <title>HTTP Status Code - 404 not found</title>
          <meta name="description" content="404 Page Not Found is the standardized HTTP status code that indicates that the server is unable to receive your request." />
          <meta name="keywords" content="404, 404 error" />
          <meta property="og:title" content="HTTP Status Code - 404 not found" />
          <meta property="og:description" content="404 Page Not Found is the standardized HTTP status code that indicates that the server is unable to receive your request." />
      </Helmet>
      
      <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center">
      <div className="text-center mb-4">
        <img src={"/images/404-page-not-found.png"} alt="" className="img-fluid" />
      </div>
        <button className="btn btn-primary" onClick={() => navigate("/")}>
          Go to Home
        </button>
      </div>
    </>
  );
}
